import React from 'react';
import { useModuleSettings } from '../../contexts/ModuleSettingsContext';

const MODULE_OPTIONS = [
  {
    key: 'access_machinery',
    label: 'Maquinarias',
    enabledKey: 'machineryEnabled',
  },
  {
    key: 'access_produccion',
    label: 'Producción',
    enabledKey: 'produccionEnabled',
  },
  {
    key: 'access_produccion_concesionaria',
    label: 'Producción concesionaria',
    enabledKey: 'produccionConcesionariaEnabled',
  },
  {
    key: 'access_restaurantes',
    label: 'Restaurantes',
    enabledKey: 'restaurantesEnabled',
  },
];

/**
 * Accesos a almacenes, puntos de venta y módulos opcionales para rol limitado.
 */
const LimitedUserAccessFields = ({
  formData,
  onModuleAccessToggle,
  warehouseOptions,
  onWarehouseToggle,
  pointOfSaleOptions = [],
  onPointOfSaleToggle,
  purchaseSiteOptions = [],
  onPurchaseSiteToggle,
}) => {
  const {
    machineryEnabled,
    produccionEnabled,
    produccionConcesionariaEnabled,
    restaurantesEnabled,
    ventasEnabled,
    comprasPurchaseSitesEnabled,
  } = useModuleSettings();

  const enabledMap = {
    machineryEnabled,
    produccionEnabled,
    produccionConcesionariaEnabled,
    restaurantesEnabled,
  };

  const activeModules = MODULE_OPTIONS.filter((m) => enabledMap[m.enabledKey]);

  return (
    <>
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Almacenes a los que puede acceder
        </label>
        <div className="border border-gray-300 rounded-md p-3 max-h-40 overflow-y-auto bg-gray-50">
          {!Array.isArray(warehouseOptions) || warehouseOptions.length === 0 ? (
            <p className="text-sm text-gray-500">No hay almacenes disponibles</p>
          ) : (
            warehouseOptions.filter((wh) => wh && wh.id).map((wh) => (
              <label key={wh.id} className="flex items-center gap-2 py-1 cursor-pointer">
                <input
                  type="checkbox"
                  checked={(formData.warehouse_ids || []).includes(wh.id)}
                  onChange={() => onWarehouseToggle(wh.id)}
                  className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                />
                <span className="text-sm text-gray-700">
                  {wh.name || ''} {wh.code ? `(${wh.code})` : ''}
                </span>
              </label>
            ))
          )}
        </div>
      </div>

      {comprasPurchaseSitesEnabled && (
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Sedes de compra a las que puede acceder
          </label>
          <div className="border border-gray-300 rounded-md p-3 max-h-40 overflow-y-auto bg-gray-50">
            {!Array.isArray(purchaseSiteOptions) || purchaseSiteOptions.length === 0 ? (
              <p className="text-sm text-gray-500">No hay sedes de compra disponibles</p>
            ) : (
              purchaseSiteOptions.filter((site) => site && site.id).map((site) => (
                <label key={site.id} className="flex items-center gap-2 py-1 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={(formData.purchase_site_ids || []).includes(site.id)}
                    onChange={() => onPurchaseSiteToggle?.(site.id)}
                    className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                  />
                  <span className="text-sm text-gray-700">
                    {site.name || ''} {site.code ? `(${site.code})` : ''}
                  </span>
                </label>
              ))
            )}
          </div>
        </div>
      )}

      {ventasEnabled && (
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Puntos de venta a los que puede acceder
          </label>
          <div className="border border-gray-300 rounded-md p-3 max-h-40 overflow-y-auto bg-gray-50">
            {!Array.isArray(pointOfSaleOptions) || pointOfSaleOptions.length === 0 ? (
              <p className="text-sm text-gray-500">No hay puntos de venta disponibles</p>
            ) : (
              pointOfSaleOptions.filter((pos) => pos && pos.id).map((pos) => (
                <label key={pos.id} className="flex items-center gap-2 py-1 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={(formData.point_of_sale_ids || []).includes(pos.id)}
                    onChange={() => onPointOfSaleToggle?.(pos.id)}
                    className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                  />
                  <span className="text-sm text-gray-700">
                    {pos.name || ''} {pos.code ? `(${pos.code})` : ''}
                  </span>
                </label>
              ))
            )}
          </div>
        </div>
      )}

      {activeModules.length > 0 && (
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Acceso a módulos
          </label>
          <p className="text-xs text-gray-500 mb-2">
            Solo se listan módulos habilitados en el sistema. Marque a cuáles puede acceder este usuario.
          </p>
          <div className="border border-gray-300 rounded-md p-3 bg-gray-50 space-y-2">
            {activeModules.map((mod) => (
              <label key={mod.key} className="flex items-center gap-2 py-1 cursor-pointer">
                <input
                  type="checkbox"
                  checked={Boolean(formData[mod.key])}
                  onChange={() => onModuleAccessToggle(mod.key)}
                  className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                />
                <span className="text-sm text-gray-700">{mod.label}</span>
              </label>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default LimitedUserAccessFields;
